// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero-banner-search-mobile .btn-search {\n  height: 47px;\n  width: 47px;\n}\n.hero-banner-search-mobile .input-what {\n  margin-right: 0px !important;\n  min-width: inherit !important;\n}", ""]);
// Exports
module.exports = exports;
